import { useCallback, useEffect, useState } from "react";
import { useDebounceAction } from "cityads-v3/utils/useUtils";
import config from "cityads-v3/config";
import { FilterCountProps } from "./FilterCount";

export function useOnChangeCallback(filterEl: React.MutableRefObject<HTMLElement>) {
  return useCallback((evt: React.ChangeEvent) => {
    filterEl.current = evt.target.closest('[data-item]')
  }, [filterEl])
}

type usePopperActionsProps = Pick<FilterCountProps, 'onApply'> & {
  isLoading: boolean
  filterEl: React.MutableRefObject<HTMLElement>
}
export function usePopperActions({
  onApply,
  isLoading = false,
  filterEl
}: usePopperActionsProps) {
  const [open, setOpen] = useState<boolean>(false)
  const closePopper = useDebounceAction(useCallback(() => {
    setOpen(false);
    filterEl.current = null
  }, [filterEl]), config.FILTER_TOTAL_SHOW_TIME);

  const openPopper = useDebounceAction(useCallback(() => {
    setOpen(true);
  }, [setOpen]), 1000);

  const handleApply = useCallback(() => {
    setOpen(false)
    onApply?.()
    filterEl.current = null
  }, [setOpen, onApply, filterEl])

  useEffect(() => {
    if (isLoading) {
      openPopper()
      closePopper()
    }
  }, [closePopper, isLoading, openPopper])

  return {
    handleApply,
    open,
  }
}
